import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['searchInput', 'clearButton']
  static values = {
    active: Boolean,
    activeClassList: Array
  }

  activeValueChanged() {
    this.#setActiveStyle()
    this.#toggleClearButton()
  }

  connect() {
    this.setActiveState()
  }

  setActiveState() {
    this.activeValue = this.searchInputTarget.value !== ''
  }

  clearInput() {
    this.searchInputTarget.value = ''
    this.activeValue = false
    this.searchInputTarget.dispatchEvent(new Event('input', { bubbles: true, composed: true }))
  }

  #setActiveStyle() {
    if (!this.activeClassListValue || this.activeClassListValue.length === 0) {
      return
    }
    if (this.activeValue === true) {
      this.searchInputTarget.classList.add(...this.activeClassListValue)
    } else {
      this.searchInputTarget.classList.remove(...this.activeClassListValue)
    }
  }

  #toggleClearButton() {
    if (this.activeValue === true) {
      this.clearButtonTarget.classList.remove('hidden')
    } else {
      this.clearButtonTarget.classList.add('hidden')
    }
  }
}
